import React from "react";

import { SuggesterTextInput } from "./SuggesterTextInput";
import { TextWithSaveButtonRow, TextWithSaveCancelButton, TextWithSaveContainer, TextWithSaveSaveButton } from "./TextInputWithSave";
import { Icon } from "../icons/Icons";

export type SuggesterTextInputWithSaveProps = {
    value: string,
    visibleOptions: { identifier?: string, text: string; }[],
    disabled?:boolean,
    onChange?: (newValue: string) => void,
    onSave: (value: string) => void,
    onSelectOption: (selection: { identifier?: string, text: string; }) => void,
    onEnterOnUnmarked?: () => void,
    onCancel?: (cancelledValue:string, restoredValue:string) => void,
};
export function SuggesterTextInputWithSave (props: SuggesterTextInputWithSaveProps): JSX.Element
{

    const [thisValue, setThisValue] = React.useState(props.value);
    const [hasFocus, setHasFocus] = React.useState(false);

    const cancelButtonRef = React.useRef(null);
    const saveButtonRef = React.useRef(null);

    React.useEffect(() => {
        setThisValue(props.value);
    }, [props.value])

    function save() {
        // only save if value has changed
        if (thisValue != props.value)
            props.onSave(thisValue);
    }

    function handleTextFocus(/*e:React.FocusEvent<HTMLInputElement>*/) {
        setHasFocus(true);
    }

    function handleTextBlur(e: React.FocusEvent<HTMLInputElement>) {
        const isCancel = e.relatedTarget === cancelButtonRef.current;
        const isSave = e.relatedTarget === saveButtonRef.current;
        
        setHasFocus(false);

        if (isCancel || isSave) {
            // Do nothing yet.
            // it will be handled by the handler
        }
        else {
            // any non-button click is implicitly saving
            save();
        }
    }

    function handleCancelClick() {
        if (thisValue != props.value){    
            setThisValue(props.value);
        }
        if(props.onCancel)
            props.onCancel(thisValue, props.value);
    }

    function handleSaveClick() {
        save();
    }

    function handleChange(newValue:string) {
        setThisValue(newValue);
        if (props.onChange)
            props.onChange(newValue);
    }

    function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
        // eslint-disable-next-line no-empty
        if (e.key === 'Tab') {
        }
        if (e.key === 'Enter') {
            save();
        }
    }

    function handleSelectOption(selection: { identifier?: string, text: string}) {
        setThisValue(selection.text);
        props.onSelectOption(selection);
    }

    return (
        <>
            <TextWithSaveContainer>

                <SuggesterTextInput
                    disabled={props.disabled}
                    text={thisValue}
                    visibleOptions={props.visibleOptions}
                    onChange={handleChange}
                    onFocus={handleTextFocus}
                    onBlur={handleTextBlur}
                    onKeyDown={handleKeyDown}
                    onSelectOption={handleSelectOption}
                    onEnterOnUnmarked={props.onEnterOnUnmarked}
                />

                <TextWithSaveButtonRow style={{ visibility: hasFocus ? "visible" : "hidden" }}>

                    <TextWithSaveCancelButton
                        ref={cancelButtonRef}
                        tabIndex={1}
                        onClick={handleCancelClick}>
                        <Icon name={"actions_close"} size={"small"} />
                    </TextWithSaveCancelButton>

                    <TextWithSaveSaveButton
                        ref={saveButtonRef}
                        tabIndex={2}
                        onClick={handleSaveClick}>
                        <Icon name={"actions_done"} size={"small"} />
                    </TextWithSaveSaveButton>

                </TextWithSaveButtonRow>

            </TextWithSaveContainer>

        </>
    );
}